import React from 'react'
// libs
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
// other
import { msalConfig } from 'providers/MicrosoftProvider/config'

type Props = React.PropsWithChildren<unknown>

const MicrosoftProvider: React.FC<Props> = ({ children }) => {
  const [instance, setInstance] = React.useState<PublicClientApplication>()

  React.useEffect(() => {
    const msalInstance = new PublicClientApplication({
      ...msalConfig,
      auth: {
        ...msalConfig.auth,
        redirectUri: window.location.origin
      }
    })

    setInstance(msalInstance)
  }, [])

  if (!instance) {
    return null
  }

  return <MsalProvider instance={instance}>{children}</MsalProvider>
}

export default MicrosoftProvider
